import React, { AnchorHTMLAttributes } from "react";
import styled from "styled-components";

type Underline = "none" | "hover" | "always";

interface Props extends AnchorHTMLAttributes<HTMLAnchorElement> {
  underline?: Underline;
  disabled?: boolean;
}

const Link: React.FC<Props> = ({
  children,
  underline = "always",
  disabled = false,
  ...other
}) => {
  return (
    <StyledLink underline={underline} disabled={disabled} {...other}>
      {children}
    </StyledLink>
  );
};

export default Link;

const underlineStyles = {
  always: `text-decoration: underline;`,
  none: `text-decoration: none;`,
  hover: `:hover {text-decoration: underline;};`,
};

const StyledLink = styled.a<{ underline: Underline; disabled: boolean }>`
  ${({ underline, disabled }) => `
    ${underlineStyles[underline]}
    ${
      disabled
        ? `
        pointer-events: none;
        opacity: 70%;`
        : ``
    }
  `}

  :hover {
    opacity: 0.8;
  }
`;
